import { UserSelectableItem } from "../User.types";
import { isNullOrWhitespace } from "@common/stringOperations.ts";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export const contractManagersUrl = "/users/contract-managers";

export function getResponsibleQueryUrl(contractId?: string) {
    if (!isNullOrWhitespace(contractId ?? undefined)) {
        return `/contract-user-access/${contractId}/selectable-responsibles`;
    }
    return "/users/responsibles";
}

export function useResponsibleQuery(isEnabled: boolean = true, contractId?: string) {
    const url = getResponsibleQueryUrl(contractId);

    const query = useDotLegalQuery<Array<UserSelectableItem>>(url, {
        notifyOnChangePropsExclusions: ["isStale"],
        staleTime: 15000,
        enabled: isEnabled,
    });

    function getSelectableResponsibles(responsible: string | undefined | null) {
        return query.data?.filter((x) => x.active || x.id === responsible);
    }

    function getSelectableResponsiblesWithIds(responsibles: Array<string>) {
        return query.data?.filter((x) => x.active || responsibles.includes(x.id));
    }

    function getSelectableResponsiblesForMultiSelect(responsibles: Array<string>) {
        return query.data?.filter((x) => x.active || responsibles.includes(x.id));
    }

    return {
        isLoading: query.isLoading,
        data: getSelectableResponsibles,
        dataByList: getSelectableResponsiblesWithIds,
        dataForMultiSelect: getSelectableResponsiblesForMultiSelect,
        userData: query.data,
    };
}
